import React, { Component } from "react";

export default class ModernRug extends Component {
  render() {
    let display = this.props.show ? "" : "none";
    return (
      <div style={{ display: display }}>
        <div className="main-carpet-kheshti">
          <div className="background-carpet">
            <img
              src={
                this.props.background && this.props.background.image
                  ? this.props.background.image
                  : "/static/img/background.png"
              }
              onDragStart={(e) => e.preventDefault()}
              alt="Background"
            />

            {/* <div className="modern-background">
              <img
                src={
                  this.props.pattern && this.props.pattern.image
                    ? this.props.pattern.image
                    : "/static/img/toranj.png"
                }
                onDragStart={(e) => e.preventDefault()}
                alt="rugs-cover-img"
              />
            </div> */}
          </div>
        </div>
      </div>
    );
  }
}
